import styled from '@emotion/styled';
import { colors } from '@modernhealth/vital-foundation';
import { useFlags } from 'launchdarkly-react-client-sdk';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactResizeDetector from 'react-resize-detector';

import {
    TextWrapper,
    MainText,
    LearnMoreText,
    CloseButtonWrapper,
} from 'src/modules/dashboard/components/TimelyResponseBanner';
import closeIcon from 'src/public/img/close-icon-white.svg';

const Wrapper = styled.div({
    width: '100%',
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    margin: '0 auto',
    backgroundColor: colors.blue05,
    transition: 'all 0.6s ease-in-out',
});

const BannerWrapper = styled.div({
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    maxWidth: 1440,
    width: '100%',
    backgroundColor: colors.gray85,
});

export const STORAGE_KEY = 'dismissed_admin_banner';

export const AdminTimelyResponseBanner = () => {
    const { t } = useTranslation();
    const { showAdminTimelyResponseBanner } = useFlags();

    const [showBanner, setShowBanner] = useState(true);
    const hideBanner = () => {
        localStorage.setItem(STORAGE_KEY, 'true');
        setShowBanner(false);
    };

    if (localStorage.getItem(STORAGE_KEY)) {
        return null;
    }

    const article = showAdminTimelyResponseBanner; // this is a variant flag; if flag is off, empty string is returned;
    const handleBannerClick = () => window.open(article, '_blank');

    return (
        <ReactResizeDetector handleHeight>
            {({ height = 49 }) => (
                <Wrapper
                    style={{ opacity: showBanner ? 1 : 0, marginTop: showBanner ? 0 : -height }}
                    data-testid="adminTimelyBanner"
                >
                    <BannerWrapper>
                        <TextWrapper>
                            <MainText>{t('admin:timely_banner.text')}</MainText>
                            <LearnMoreText onClick={handleBannerClick}>
                                {t('dashboard:learn_more')}
                            </LearnMoreText>
                        </TextWrapper>

                        <CloseButtonWrapper onClick={hideBanner}>
                            <img src={closeIcon} alt={t('common.close')} />
                        </CloseButtonWrapper>
                    </BannerWrapper>
                </Wrapper>
            )}
        </ReactResizeDetector>
    );
};
